import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

//
import Moment from "react-moment";

//
import { useTable, useSortBy } from "react-table";

//
import ReactTable from "../general/ReactTable";
import ImageBox from "../general/ImageBox";

//
import SmallChart from "./SmallChart";

//
import { iconImage } from "../../redux/features/coins/actions";

function DesktopAvailableCoins({ items, apiSort }) {
  // begim::table
  const data = items;

  const columns = React.useMemo(
    () => [
      {
        Header: "Coin",
        accessor: "name", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;
          let symbol = cellProps.row.original.symbol;

          return (
            <div className="d-flex align-items-center">
              <ImageBox src={iconImage(symbol.split("/")[0])} alt={value} />

              <Link
                to={`/app/coin-detail/${symbol.split("/")[0]}`}
                className="d-flex align-items-baseline fw-bolder text-dark"
              >
                <p className="text-black">{value}</p>
                <small className="text-muted">({symbol})</small>
              </Link>
            </div>
          );
        },
      },
      {
        Header: "success rate",
        accessor: "success_rate", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;

          return (
            <small className="text-black">{Number(value).toFixed(2)}%</small>
          );
        },
      },
      {
        Header: "last 3 month success rate",
        accessor: "success_rate_3months", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;

          return (
            <small className="text-black">{Number(value).toFixed(2)}%</small>
          );
        },
      },
      {
        Header: "daily volume change",
        accessor: "percent_change_24h", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.row.original.marketDetails.percent_change_24h;
          let chartData = cellProps.row.original.VolumeChartData_24;

          return (
            <div className="chart-box">
              <small
                className={`percent ${
                  value > 0 ? "text-success" : "text-danger"
                }`}
              >
                {value.toFixed(2)}%
                <i className={`las la-arrow-${value > 0 ? "up" : "right"}`} />
              </small>
              <SmallChart data={chartData} last={value} />
            </div>
          );
        },
      },
      {
        Header: "count alert",
        accessor: "total_signals", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;

          return <small className="text-black">{value}</small>;
        },
      },
      {
        Header: "avg. max. profit per alert",
        accessor: "avg_max_profit", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;

          return <small className="text-black">{value}%</small>;
        },
      },
      {
        Header: "time interval",
        accessor: "first_signal_date", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;

          return (
            <small className="text-black">
              <Moment utc fromNow>
                {value}
              </Moment>
            </small>
          );
        },
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data }, useSortBy);
  // end::table
  return (
    <ReactTable
      rows={rows}
      sort
      apiSort={apiSort}
      bodySpace
      prepareRow={prepareRow}
      headerGroups={headerGroups}
      getTableProps={getTableProps}
      getTableBodyProps={getTableBodyProps}
    />
  );
}

DesktopAvailableCoins.propTypes = {
  items: PropTypes.array.isRequired,
};

export default DesktopAvailableCoins;
